import { imageBadgeStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge";
import { css } from "styled-components";

imageBadgeStyles.container = {
    css: css`
        margin-top: 12px;
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        & img {
            max-width: 100%;
            height: auto;
            max-height: 100%;
        }
    `,
};
imageBadgeStyles.imageContainer = {
    css: css`
        gap: 12px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    `,
};
imageBadgeStyles.imageItem = {
    css: css`
        max-width: 20px;
        max-height: 20px;
        flex-basis: 20px;
    `,
};
